module.exports = __webpack_public_path__ + "static/media/stop.89691b8f.mp3";